import React, { useMemo, useState } from 'react';
import { HGTable } from 'components/HGTable';
import { useGetIDsFromURL } from '../DeviceDetails/helper';
import { useGetSiteData } from './helper';
import { devicesTableColumns } from './tableColumns';
import { getDeviceLink } from '../DeviceList/helper';

const DevicesTable = () => {
    const { Site_ID } = useGetIDsFromURL();
    const { data: siteData, isLoading } = useGetSiteData(Site_ID);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState(1);
    const devices = useMemo(
        () => siteData?.Things?.items ?? [],
        [siteData?.Things?.items]
    );

    return (
        <div>
            <HGTable
                columns={devicesTableColumns}
                loading={isLoading}
                rowsHref={(item) => getDeviceLink(item)}
                data={devices.map((device) => {
                    //hardcoding thing type to friendly readable name for now
                    device.ThingType =
                        device?.ThingType?.replace('_', ' ') || 'Unknown';
                    return device;
                })}
                sortField={sortField}
                setSortField={setSortField}
                sortDirection={sortDirection}
                setSortDirection={setSortDirection}
                currentPage={1}
                setCurrentPage={() => {}}
                pageSize={devices.length}
                totalItems={devices.length}
            />
        </div>
    );
};

export default DevicesTable;
